import { useTranslation } from '@sib/i18n';
import { cn, Loader } from '@sib/ui';

export interface SibTableDelayedLoadingIndicatorProps {
  width: number;
  label?: string;
  visible?: boolean;
  isEmpty?: boolean;
}

export const SibTableDelayedLoadingIndicator = ({
  width,
  label,
  visible = false,
  isEmpty = false,
}: SibTableDelayedLoadingIndicatorProps) => {
  const { t } = useTranslation();

  return (
    <div
      style={{ left: width / 2 }}
      className={cn(
        {
          'opacity-100': visible && !isEmpty,
          'pointer-events-none opacity-0': !visible && !isEmpty,
        },
        'sticky top-1/2 z-1 flex w-auto max-w-0 -translate-x-1/2 -translate-y-1/2 items-center justify-center overflow-visible transition-opacity duration-300'
      )}
    >
      <p className="text-md left-1/2 flex min-w-fit items-center gap-2 whitespace-pre">
        {label || t('components.dataTable.loading')}
        <Loader />
      </p>
    </div>
  );
};
